import { Environment } from '@lendi/lala-utils';

import { API_URL as BASE_API_URL } from '@funnels/constants';
import { SERVER_CREDIT_REPORTS } from '@funnels/mockdata';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';

const environment = process.env['REACT_APP_ENV'] as Environment;

const API_URL = `${BASE_API_URL}/api/v1`;

const API_URL_TO_USE =
  environment === Environment.Staging || environment === Environment.Production
    ? API_URL
    : 'https://6459bb7c-2d7c-4179-9682-e1e053cde016.mock.pstmn.io/api/v1';

function fetch(applicantId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve(SERVER_CREDIT_REPORTS[0]);
  }

  return axios.get(`${API_URL_TO_USE}/credit-reports/applicants/${applicantId}/summary`).then((res) => res.data);
}

const creditReportsApi = { fetch };

export default creditReportsApi;
